module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XII",
      "title": "XII"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-002"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "The Ancient Mariner keeps watch at Watchet Harbour: like his mariner, Coleridge endured the agony of loneliness and despair, but also like him he survived the ordeal and was rewarded with a visionary experience of transﬁgured beauty in the world.",
      "src": "images/pg_12_statue.jpg"
    }
  })]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Ancient Mariner keeps watch at Watchet Harbour: like his mariner, Coleridge endured the agony of loneliness and despair, but also like him he survived the ordeal and was rewarded with a visionary experience of transﬁgured beauty in the world.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0